module.exports = __webpack_public_path__ + "img/ico-whatsapp.da26f337.png";